import { ActionReducerMapBuilder, createAction, createSlice, PayloadAction } from '@reduxjs/toolkit'
import isArray from 'lodash/isArray'

import { FETCH_USER_PERMISSIONS_SUCCESS } from '../../actions/user'
import { IUserPermission } from '../../models/portal/permissions'

export type UserPermissionsState = { permissions: IUserPermission[] }

export const initialUserPermissionsState: UserPermissionsState = {
    permissions: [],
}

export const gotUserPermissions = createAction<{ userPermissions: IUserPermission[] | null }>(
    FETCH_USER_PERMISSIONS_SUCCESS
)

function handleUserPermissions(
    state: UserPermissionsState,
    { payload }: PayloadAction<{ userPermissions: IUserPermission[] | null }>
) {
    state.permissions = isArray(payload.userPermissions)
        ? [...payload.userPermissions]
        : initialUserPermissionsState.permissions
}

const extraReducers = (builder: ActionReducerMapBuilder<UserPermissionsState>): void => {
    builder.addCase(gotUserPermissions, handleUserPermissions)
}

const userPermissionsSlice = createSlice({
    name: 'userPermissions',
    initialState: initialUserPermissionsState,
    reducers: {},
    extraReducers,
})

export default userPermissionsSlice
